import { Pause, Play, RotateCcw, SkipForward, Flag } from "lucide-react";
import { useCity } from "../state/CityContext";
import { DURATION, STEP } from "../simulation/types";
import { clock } from "./Primitives";
export function Timeline({ onOutcome }: { onOutcome: () => void }) {
  const { state, dispatch } = useCity();
  return (
    <section className="timeline" aria-label="Simulation playback">
      <div className="timeline-top">
        <span className="eyebrow">
          <span className={`live-dot ${state.playing ? "playing" : ""}`} />{" "}
          {state.playing
            ? "SIMULATION RUNNING"
            : state.run.minute === DURATION
              ? "SIMULATION COMPLETE"
              : "SIMULATION PAUSED"}
        </span>
        <span className="timeline-time">
          {clock(state.run.minute)} <small>+{state.run.minute} min</small>
        </span>
        <button className="outcome-button" onClick={onOutcome}>
          <Flag size={13} /> Outcomes
        </button>
      </div>
      <div className="timeline-track">
        <button
          className="play-button"
          aria-label={state.playing ? "Pause simulation" : "Play simulation"}
          onClick={() => dispatch({ type: "play" })}
        >
          {state.playing ? (
            <Pause size={18} fill="currentColor" />
          ) : (
            <Play size={18} fill="currentColor" />
          )}
        </button>
        <button
          className="icon-button"
          aria-label="Advance five minutes"
          title="Advance five minutes"
          disabled={state.run.minute === DURATION}
          onClick={() =>
            dispatch({ type: "time", minute: state.run.minute + STEP })
          }
        >
          <SkipForward size={16} />
        </button>
        <div className="scrubber">
          <label className="sr-only" htmlFor="timeline">
            Simulated minute
          </label>
          <input
            id="timeline"
            type="range"
            min="0"
            max={DURATION}
            step={STEP}
            value={state.run.minute}
            onChange={(e) =>
              dispatch({ type: "time", minute: Number(e.target.value) })
            }
          />
          <div className="tick-labels">
            <span>08:00</span>
            <span>08:30</span>
            <span>09:00</span>
            <span>09:30</span>
            <span>10:00</span>
          </div>
          <div className="decision-ticks" aria-hidden="true">
            {state.run.decisions
              .filter((d) => d.delta === 1)
              .map((d) => (
                <i
                  key={d.id}
                  style={{ left: `${(d.minute / DURATION) * 100}%` }}
                />
              ))}
          </div>
        </div>
        <button
          className="speed-button"
          aria-label={`Playback speed ${state.speed} times. Click to change.`}
          onClick={() => dispatch({ type: "speed" })}
        >
          {state.speed}×
        </button>
        <button
          className="icon-button"
          aria-label="Replay from beginning, preserving response decisions"
          title="Replay from beginning"
          onClick={() => {
            dispatch({ type: "time", minute: 0 });
          }}
        >
          <RotateCcw size={16} />
        </button>
      </div>
    </section>
  );
}
